exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid-radio-column[data-v-1627e720] {\n  display: none;\n}\n", ""]);

// exports
